<template>
    <div class="narrowcolright">
        <slot />
    </div>
</template>